module.exports = __webpack_public_path__ + "img/ENERGIESANTERRE.f3c27fe6.png";